import { useMemo } from 'react'
import type { Customer } from '../../../../api/useFreight/types/dashboard'

/**
 * Hook to filter customers based on error/warning status
 * @param customers Array of customer data
 * @param showErrorsOnly Flag to show only customers with errors or warnings
 * @returns Filtered customer array
 */
export function useFilteredCustomers(customers: Customer[] | undefined, showErrorsOnly: boolean): Customer[] {
  return useMemo(() => {
    if (!customers) {
      return []
    }

    if (showErrorsOnly) {
      return customers.filter((customer) => customer.errorCounts > 0 || customer.warningCounts > 0)
    }

    return customers
  }, [customers, showErrorsOnly])
}
